<script>
    import AdminList from '../_List';
    import TableRow from './_Row';

    export default {
        extends: AdminList,

        data: () => ({
            cols: ['Solution', 'Typ', 'Kategorien', 'Tags', 'Aktualisiert', ''],
            TableRow,
            removeRow: null,
            removeModal: {
                text: 'Soll die Solution wirklich gelöscht werden?',
                button: 'Solution löschen',
                error: 'Die Solution konnte nicht gelöscht werden.',
            },
        }),
    };
</script>
